import styled from "styled-components";

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 500px) {
    justify-content: center;
  }
`;

export default Header;
